import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.5",
  height: "17.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" stroke=\"#fff\" stroke-linejoin=\"round\" stroke-width=\"1.5\" data-name=\"Ikona MENU Kalendarz\" transform=\"translate(.75 .75)\"><rect width=\"16\" height=\"14.911\" data-name=\"Rectangle 2661\" rx=\"1.5\" transform=\"translate(0 1.089)\"></rect><path stroke-linecap=\"round\" d=\"M4 0v2.18\" data-name=\"Path 4849\"></path><path stroke-linecap=\"round\" d=\"M12 0v2.18\" data-name=\"Path 4850\"></path><path stroke-linecap=\"round\" d=\"M15.423 5.402H.001\" data-name=\"Path 4851\"></path></g>", 1)
  ]))]))
}
export default { render: render }